import { faList } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';

import { ControlPanelButton, ControlPanelButtonTooltip } from '../../components/ControlPanelButton';
import { DrawerButton } from '../../components/DrawerButton';
import { IconMenuItem } from '../../components/IconMenuItem';
import { VisitorDrawerState } from '../state';
import { useReflectionTopicsDrawerControl } from './useReflectionTopicsDrawerControl';

export type ReflectionTopicsDrawerControlsProps = {
  className?: string;
  drawerId: string;
  isDrawerOpen: boolean;
  onClick: () => void;
  tooltipText: string;
};
export function ReflectionTopicsDrawerControls({
  className,
  drawerId,
  isDrawerOpen,
  onClick,
  tooltipText,
}: ReflectionTopicsDrawerControlsProps) {
  return (
    <div className={className}>
      <ControlPanelButtonTooltip childIsInteractive text={tooltipText}>
        <DrawerButton
          forDrawerStates={VisitorDrawerState.REFLECTION_TOPICS}
          aria-label={tooltipText}
          aria-expanded={isDrawerOpen}
          aria-controls={drawerId}
          iconDefinition={faList}
          as={ControlPanelButton}
          onClick={onClick}
        />
      </ControlPanelButtonTooltip>
    </div>
  );
}

export function ReflectionTopicsDrawerControlsWrapper(
  props: Pick<ReflectionTopicsDrawerControlsProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useReflectionTopicsDrawerControl();

  return shouldShowButton ? (
    <ReflectionTopicsDrawerControls {...props} isDrawerOpen={isDrawerOpen} onClick={onClick} tooltipText={helperText} />
  ) : null;
}

export type ReflectionTopicsDrawerControlMenuItemProps = {
  className?: string;
  drawerId: string;
  helperText: string;
  isDrawerOpen: boolean;
  onClick: () => void;
};

export function ReflectionTopicsDrawerControlMenuItem({
  className,
  drawerId,
  helperText,
  isDrawerOpen,
  onClick,
}: ReflectionTopicsDrawerControlMenuItemProps) {
  const t = useTranslate();
  return (
    <IconMenuItem
      aria-controls={drawerId}
      aria-expanded={isDrawerOpen}
      onClick={onClick}
      className={className}
      icon={faList}
    >
      <span className='sr-only'>{helperText}</span>
      <span aria-hidden>{t('telehealth-core:controls.sessionTopics')}</span>
    </IconMenuItem>
  );
}

export function ReflectionTopicsDrawerControlMenuItemWrapper(
  props: Pick<ReflectionTopicsDrawerControlMenuItemProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useReflectionTopicsDrawerControl();

  return shouldShowButton ? (
    <ReflectionTopicsDrawerControlMenuItem
      {...props}
      helperText={helperText}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
    />
  ) : null;
}
